import React from "react";
var __jsx = React.createElement;
import { useEffect } from 'react';
import { useTranslation } from '@i18n';
import AnyQustV2 from '@/pages/homePageV2/homePageComponents/components/AnyQust/AnyQustV2';
var PhoneContactPopup = function PhoneContactPopup(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    customTitle = _ref.customTitle,
    customWorkingHours = _ref.customWorkingHours,
    phoneNumber = _ref.phoneNumber,
    whatsappNumber = _ref.whatsappNumber;
  var _useTranslation = useTranslation(['web_sell_trade']),
    tShort = _useTranslation.tShort;

  // Handle body scroll lock
  useEffect(function () {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return function () {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;

  // Create translation-based content
  var title = customTitle || tShort('contact_popup/title', {
    ns: 'web_sell_trade'
  });
  var workingHoursLine1 = tShort('contact_popup/working_hours_line1', {
    ns: 'web_sell_trade'
  });
  var workingHoursLine2 = tShort('contact_popup/working_hours_line2', {
    ns: 'web_sell_trade'
  });
  var workingHoursLine3 = tShort('contact_popup/working_hours_line3', {
    ns: 'web_sell_trade'
  });
  var workingHours = customWorkingHours || "".concat(workingHoursLine1, "\n").concat(workingHoursLine2, "\n").concat(workingHoursLine3);
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4 md:p-5",
    onClick: function onClick(e) {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-2xl relative max-w-[560px] w-full max-h-[90vh] overflow-auto"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "absolute top-4 right-4 bg-transparent border-none text-2xl cursor-pointer text-[#666] p-2 rounded-full w-10 h-10 flex items-center justify-center hover:bg-[#f5f5f5] transition-colors duration-200 z-10"
  }, "\u2715"), /*#__PURE__*/React.createElement(AnyQustV2, {
    customTitle: title,
    customWorkingHours: workingHours,
    customLocation: "PopupContact",
    hideContainer: true,
    useWhiteDesign: true
  })));
};
export default PhoneContactPopup;